// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  Version: '5.1.2.3',
  ReleaseDate: '14-08-2020',
  firebase: {
    apiKey: 'AIzaSyCPhyB9OX3VbD_HNYo1_0JrWc-PuMnzEJs',
    authDomain: 'ipos-pos.firebaseapp.com',
    databaseURL: 'https://ipos-pos.firebaseio.com',
    projectId: 'ipos-pos',
    storageBucket: 'ipos-pos.appspot.com',
    messagingSenderId: '839916692746',
    appId: '1:839916692746:web:1304e64a98dd3ac2ab46f3',
    measurementId: 'G-CBYY9R6EHH'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
